<template>
    <el-form class="loginForm md-layout md-alignment-center-center"
             label-width="150px"
             label-position="left">
        <md-card class="md-layout-item md-large-size-50 md-size-70 md-small-size-80">
            <md-toolbar :md-elevation="1">
                <span class="md-title">Profile Information</span>
            </md-toolbar>
            <md-list class="md-double-line">
                <md-subheader>Account</md-subheader>
                <md-divider></md-divider>
                <md-list-item style="padding-top: 10px">
                    <el-form-item class="form-item" label="Company Name">
                        <el-input :disabled="true"
                                  v-model="user.company_name"></el-input>
                    </el-form-item>
                </md-list-item>
                <md-list-item>
                    <el-form-item label="Full Name">
                        <el-input :disabled="!editing_profile"
                                  v-model="user.full_name">
                        </el-input>
                    </el-form-item>
                </md-list-item>
                <md-list-item>
                    <el-form-item
                            style="white-space:pre-line; line-height: 20px"
                            label="Available Old Network Service Providers">
                        <div class="tag-group">
                            <el-tag
                                    style="margin-right: 5px; color: #4F4D4C"
                                    v-for="item in user.entity"
                                    :key="item.id"
                                    type="info"
                                    hit
                                    effect="light">
                                {{ item.name }}
                            </el-tag>
                        </div>
                    </el-form-item>
                </md-list-item>
            </md-list>

            <md-list class="md-double-line">
                <md-subheader>Contact e-mail</md-subheader>

                <md-divider></md-divider>
                <md-list-item style="padding-top: 10px">
                    <el-form-item label="Notification e-mail">
                        <el-input :disabled="!editing_profile"
                                  v-model="user.notification_email">
                        </el-input>
                    </el-form-item>
                </md-list-item>
            </md-list>
            <md-card-actions style="padding: 0px 16px 16px;">
                <el-button v-if="!editing_profile"
                           class="md-alignment-center-right"
                           @click="EditProfile()"
                           type="primary">Edit
                </el-button>
                <el-button v-if="editing_profile"
                           class="md-alignment-center-right"
                           @click="CancelEdit()"
                           plain
                           :disabled="executing_profile_update"
                           type="primary">Cancel
                </el-button>
                <el-button v-if="editing_profile"
                           class="md-alignment-center-right"
                           :disabled="IsEditingDisabled()"
                           @click="SaveProfile()"
                           :loading="executing_profile_update"
                           type="success">Save
                </el-button>
            </md-card-actions>
        </md-card>
    </el-form>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "ProfileView",
        data() {
            return {
                editing_profile: false,
                cached_profile: {
                    full_name: '',
                    notification_email: ''
                },
            }
        },
        watch: {
            show_notification: function (newVal) {
                if (newVal === true) {
                    this.$notify({
                        title: this.notification['type'].charAt(0).toUpperCase() + this.notification['type'].slice(1),
                        message: this.notification['text'],
                        type: this.notification['type'],
                        position: 'top-right',
                    });

                }
            },
            executing_profile_update: function (newVal, oldVal) {
                if (newVal === false && oldVal === true) {
                    this.editing_profile = false;
                }
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                open_profile: state => state.auth.open_profile,
                notification: state => state.auth.notification,
                show_notification: state => state.auth.show_notification,
                executing_profile_update: state => state.auth.executing_profile_update,
            }),
        },
        created() {
            this.$store.dispatch('auth/getProfile', this.user.id)
        },
        methods: {
            IsEditingDisabled() {
                if (!this.editing_profile) return true
                if (this.user.full_name === this.cached_profile.full_name
                    && this.user.notification_email === this.cached_profile.notification_email)
                    return true
            },
            EditProfile() {
                this.editing_profile = true;
                this.cached_profile.full_name = this.user.full_name
                this.cached_profile.notification_email = this.user.notification_email
            },
            CancelEdit() {
                this.editing_profile = false;
                this.user.full_name = this.cached_profile.full_name
                this.user.notification_email = this.cached_profile.notification_email
            },
            SaveProfile() {
                let payload = {id: this.user.id}
                if (this.user.full_name !== this.cached_profile.full_name) {
                    payload['full_name'] = this.user.full_name
                }
                if (this.user.notification_email !== this.cached_profile.notification_email) {
                    payload['notification_email'] = this.user.notification_email
                }
                this.$store.dispatch('auth/updateProfile', payload)
            }
        }
    }
</script>

<style>
    .md-list-item-default > .md-list-item-content {
        display: table
    }
</style>

<style scoped>
    .md-list-item {
        height: 65px;
    }

    form {
        padding-top: 30px;
    }

    .md-subheader {
        font-size: 16px;
        color: #4F4D4C
    }

    .el-input.is-disabled /deep/ .el-input__inner {
        color: #4F4D4C
    }

    button {
        font-weight: 500;
    }

    .el-form /deep/ .el-form-item__label
    {
        line-height: inherit;
    }

</style>